import moment from "moment";
import { EMPTY_STRING, FALSE_STRING, TRUE_STRING } from "../../constants";

// compare string case incessitive
export const isStringEqual = (a, b) => {
  return typeof a === "string" && typeof b === "string"
    ? a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0
    : a === b;
};

// remove duplicate values of array of string
export const getArrayUniqueValues = (arr) => {
  return [...new Set(arr)];
};

export const isDateOlderThanToday = (date) => {
  return new moment(date) < new moment();
};

export const stringToTitleCase = (str) => {
  return str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
};

// Returns select options for react-select component from an array of strings or a single string
export const handleCreateSelectOptions = (arrayOfStrings) => {
  return Array.isArray(arrayOfStrings)
    ? arrayOfStrings
        .map((item) => String(item))
        .filter((item) => item) //exclude null values
        .map((item) => ({
          value: item,
          label: item,
        }))
    : typeof arrayOfStrings === "string"
    ? { value: arrayOfStrings, label: arrayOfStrings }
    : arrayOfStrings;
};

//Exclude null columns;
export const excludeNullColumns = (columns) => {
  return columns.filter(
    (column) =>
      column !== null &&
      column !== undefined &&
      column !== false &&
      column !== EMPTY_STRING
  );
};
export const toTitleCase = (str) => {
  return str.toLowerCase().replace(/\w\S*/g, function (text) {
    return text.charAt(0).toUpperCase() + text.substring(1);
  });
};

export const handleConvertStringBooleanIntoBoolean = (value) => {
  return typeof value === "boolean"
    ? value
    : String(value).toLowerCase() === TRUE_STRING
    ? true
    : String(value).toLowerCase() === FALSE_STRING
    ? false
    : false;
};

export const handleProductSaleTypeChange = (option, setFieldValue) => {
  setFieldValue("isSeparateQuantity", option);
};

export const getIsHideNonInventoryOptions = (store) => {
  return store.isHideNonInventoryOperations || false;
};

export const handleNumberSubmit = (value) => {
  let stringValue = String(value);
  if (
    stringValue.includes("null") ||
    stringValue.includes("NaN") ||
    stringValue.includes("undefined") ||
    stringValue.includes("NaN.undefined")
  ) {
    return 0;
  }
  return value;
};

export const handleIsInvalidInteger = (value) => {
  let stringValue = String(value);
  if (
    stringValue.includes("null") ||
    stringValue.includes("NaN") ||
    stringValue.includes("undefined") ||
    stringValue.includes("NaN.undefined") ||
    value === null ||
    value === undefined ||
    value === NaN
  ) {
    return true;
  }
  return false;
};

export const sum = (num1, num2) => {
  return Number(num1) + Number(num2);
};

export const getRandomNumber = () => {
  return Math.random();
};

export const removeDuplicatesFromArrOfString = (arr) => [...new Set(arr)];
